/**
 * Апи для работы с событиями
 */
export default class EventApi
{
    public static readonly ZOOM_ITEMS = 'zoom_items';
    public static readonly HAND_TO_TABLE_ANIMATE = 'hand_to_table_animate';
    public static readonly TABLE_ITEM_CREATED = 'hand_item_created';
    public static readonly SHOW_CONTEXT_MENU = 'show_context_menu';
    public static readonly MOVE_TABLE_ITEM = 'show_context_menu';
    public static readonly SET_TABLE_ZOOM = 'set_table_zoom';
    public static readonly SHUFFLE_DECK = 'shuffle_deck';
    public static readonly REFRESH_HAND_ITEMS = 'refresh_hand_items';
    public static readonly START_SOUND = 'start_sound';
    public static readonly CHECK_TABLE_IS_OPENED = 'check_table_is_opened';
    public static readonly TABLE_IS_LOADED = 'table_is_loaded';
    public static readonly SHOW_TABLE_LOADER = 'show_table_loader';
    public static readonly SHOW_PAGE_LOADER = 'show_page_loader';
    public static readonly TABLE_DRAG_STARTED = 'table_drag_started';
    public static readonly TABLE_DRAG_ENDED = 'table_drag_ended';
    public static readonly OPEN_CATALOG = 'open_catalog';
    public static readonly VIDEO_CONFERENCE_READY = 'video_conference_ready';
    public static readonly REFRESH_SCROLL_CHAT = 'refresh_scroll_chat';
    public static readonly SHOW_VIDEO = 'show_video';
    public static readonly HIDE_VIDEO = 'hide_video';
    public static readonly DEVICES_READY = 'DEVICES_READY';
    public static readonly TOGGLE_FPS_COUNTER = 'toggle_fps_counter';
    public static readonly SHOW_SUGGESTED_TASK = 'show_suggested_task';
    public static readonly DEVICES_ACCESS_GRANTED = 'devices_access_granted';
    public static readonly START_EXTERNAL_VOTING = 'start_external_voting';
    public static readonly HIDE_EXTERNAL_VOTING = 'hide_external_voting';
    public static readonly SHOW_EXTERNAL_VOTE_RESULT = 'show_external_vote_result';
    public static readonly HIDE_EXTERNAL_VOTE_RESULT = 'hide_external_vote_result';
    public static readonly SHOW_RESTART_GAME_MODAL = 'show_restart_game_modal';
    public static readonly MAKE_VOTING_DECISION = 'make_voting_decision';
    public static readonly RESET_AUDIO_THEME = 'reset_audio_theme';
    public static readonly LOGIN_WITH_TOKEN = 'login_with_token';
    public static readonly RESET_GAME = 'reset_game';
    public static readonly REFRESH_CHAT = 'refresh_chat';
    public static readonly EVENT_SEND_MESSAGE = 'sendMessage';
    public static readonly EVENT_START_DICES_ANIMATION = 'start_dices_animation';
    public static readonly UPDATE_TASK_CONTAINER_WIDTH = 'update_task_container_width';
    public static readonly EVENT_DISABLE_PARSE_MESSAGES = 'disableParseMessages';
    public static readonly EVENT_ENABLE_PARSE_MESSAGES = 'enableParseMessages';
    public static readonly EVENT_CHANGE_LAYOUT = 'event_change_layout';
    public static readonly CHANGE_CAMERA_STATUS = 'change_camera_status';
    public static readonly START_INTRO = 'start_intro';
    public static readonly EDIT_MODE_ON = 'edit_mode_on';
    public static readonly EDIT_MODE_OFF = 'edit_mode_off';
    public static readonly EDIT_MODE_KEY = 'edit_mode_key';
    public static readonly EDIT_START = 'edit_start';
    public static readonly EDIT_DONE = 'edit_done';
    public static readonly EDIT_BREAK = 'edit_break';
    public static readonly EDIT_SMALL_SIZE = 'edit_small_size';
    public static readonly SHOW_AUTOMATIONS = 'show_automations';
    // это 2 разных события для разных целей
    public static readonly HIDE_AUTOMATIONS = 'hide_automations';
    public static readonly CLOSE_AUTOMATIONS = 'close_automations';
    public static readonly ADD_AUTOMATION = 'add_automation';
    public static readonly DELETE_AUTOMATION = 'delete_automation';
    public static readonly UPDATE_AUTOMATION = 'update_automation';
    public static readonly CLOSE_SETTINGS_MODAL = 'close_settings_modal';
    public static readonly TABLE_CAMERA = 'table_camera';
    public static readonly TABLE_MICROPHONE = 'table_microphone';
    public static readonly CAMERA_STATUS_CHANGED = 'camera_status_changed';
    public static readonly MICROPHONE_STATUS_CHANGED = 'microphone_status_changed';
    public static readonly REMOTE_MEDIA_ADDED = 'remote_media_added';
    public static readonly REMOTE_MEDIA_REMOVED = 'remote_media_removed';
    public static readonly CHANGE_HAND_VISIBILITY = 'change_hand_visibility';
    public static readonly EXIT_SEAT = 'exit_seat';
    public static readonly LOCAL_TRACK_PUBLISHED = 'local_track_published';
    public static readonly UPDATE_SEATS_ON_TABLE = 'update_seats_on_table';

    private static preventKeyEvents: boolean = false;

    public static getPreventKeyEvents(): boolean
    {
        return this.preventKeyEvents;
    }
    public static setPreventKeyEvents(value: boolean): void
    {
        this.preventKeyEvents = value;
    }

    /**
     * Тригер события
     * @param {string} eventName
     * @param data
     */
    public static triggerEvent(eventName: string, data?: any): void
    {
        if (typeof CustomEvent === 'function') {
            let event = new CustomEvent(eventName, {
                detail: data
            });
            document.dispatchEvent(event);
        } else {
            let event = document.createEvent('CustomEvent');
            event.initCustomEvent(eventName, false, false, data);
            document.dispatchEvent(event);
        }
    }

    /**
     * Добавление слушателя событий
     * @param eventName
     * @param handler
     */
    public static addEventListener(eventName: string, handler: EventListenerOrEventListenerObject): void
    {
        document.addEventListener(eventName, handler, false);
    }

    /**
     * Удаление слушателя событий
     * @param eventName
     * @param handler
     */
    public static removeEventListener(eventName: string, handler: EventListenerOrEventListenerObject): void
    {
        document.removeEventListener(eventName, handler, false);
    }
}
